import { api } from "../services/axios"
import { useMutation } from "react-query"
import { toast } from "react-toastify"

export const useLogin = () => {
  return useMutation(
    async (login) => {
      const { data } = await api.post(`/token`, login)
      return data
    },
    {
      onError: (err) => {
        toast.error(err?.response?.data?.message, {
          toastId: "action_login",
        });
      }
    }
  )
}

export const useCredentialsByTokens = () => {
  return useMutation(
    async (req) => {
      const { data } = await api.post(`/token/validar`, req);
      localStorage.setItem('token-opti', data?.token)
      api.defaults.headers["Authorization"] = `Bearer ${data?.token}`

      return data;
    }
  );
};

export const useGetTokenSincronizar = () => {
  return useMutation(
    async (id) => {
      const { data } = await api.post(`/token/sincronizar/${id}`);
      return data;
    },
    {
      onError: (err) => {
        toast.error(err?.response?.data?.message, {
          toastId: "token_ sincronizarAnalytics",
        });
      }
    }
  );
};